import { render, staticRenderFns } from "./AreaTree.vue?vue&type=template&id=b0c05e88&scoped=true&"
import script from "./AreaTree.vue?vue&type=script&lang=ts&"
export * from "./AreaTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c05e88",
  null
  
)

export default component.exports